import { EnvironmentService } from '@core/services/environment.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import type { DocumentType, PaymentDetails, PaymentDetailsStatus, ResponseConfirmOperation } from '@core/services/daviplata.interface';
import { encodeApiPathSegment } from '@core/utils/api-path.utils';

@Injectable({
  providedIn: 'root'
})
export class FormPayinService {
  private get baseUrl(): string {
    return this.environmentService.env.apiConfig.payinCheckoutBackendUrl;
  }

  private operationPath(idTransaction: string): string {
    return encodeApiPathSegment(idTransaction);
  }

  constructor(
    private environmentService: EnvironmentService,
    private http: HttpClient,
  ) { }

  findDocumentByCountry(): Observable<DocumentType[]> {
    return this.http.get<DocumentType[]>(`${this.baseUrl}common/master-parameters/api/find/documentCountry/COL?documentType=N`);
  }

  confirmOperation(idTransaction: string, body: any, verification: string): Observable<PaymentDetailsStatus> {
    const headers = new HttpHeaders({
      verification,
    });
    return this.http.post<PaymentDetailsStatus>(
      `${this.baseUrl}processor/niubiz/wallet/operation/confirm/${this.operationPath(idTransaction)}`,
      body,
      { headers },
    );
  }

  expirateOperation(idTransaction: string, verification: string): Observable<ResponseConfirmOperation> {
    const headers = new HttpHeaders({
      verification,
    });
    return this.http.post<ResponseConfirmOperation>(
      `${this.baseUrl}processor/daviplata/operation/expire/${this.operationPath(idTransaction)}`,
      null,
      { headers },
    );
  }

  getPaymentDetails(idTransaction: string, verification: string): Observable<PaymentDetails> {
    const headers = new HttpHeaders({
      verification,
    });

    return this.http.post<PaymentDetails>(
      `${this.baseUrl}common/operation/find/${this.operationPath(idTransaction)}`,
      {},
      { headers },
    );
  }
}
